import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { AboutPage } from './pages/AboutPage';
import { SwitchPage } from './pages/SwitchPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
import { ContactPage } from './pages/ContactPage';
import { ScrollToTop } from './components/ScrollToTop';
export function App() {
  return <>
      <ScrollToTop data-id="element-0" />
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        <Route path="/about" element={<AboutPage data-id="element-5" />} data-id="element-4" />
        <Route path="/switch" element={<SwitchPage data-id="element-7" />} data-id="element-6" />
        <Route path="/privacy" element={<PrivacyPage data-id="element-9" />} data-id="element-8" />
        <Route path="/terms" element={<TermsPage data-id="element-11" />} data-id="element-10" />
        <Route path="/contact" element={<ContactPage data-id="element-13" />} data-id="element-12" />
      </Routes>
    </>;
}